export default class Certificate {
    static fromData(data) {
        if (!data) {
            return;
        }

        const certificate = new Certificate();
        certificate.id = data.id;
        certificate.type = data.type;
        certificate.filename = data.filename;
        certificate.created = data.created;
        certificate.creator = data.creator;
        certificate.email = data.email;
        certificate.sent = data.sent;

        return certificate;
    }

    serialize() {
        return {
            key: this.id,
        };
    }
}
